export default {
  components: {
    styleOverrides: {
      separator: {
        marginLeft: 4,
        marginRight: 4
      }
    }
  }
};
